module.exports = __webpack_public_path__ + "static/media/fly0215.68c292b9.webp";